export default __webpack_public_path__ + "static/media/rosie_deering.93e74316.jpeg";